export default "__VITE_ASSET__B_ivpZpM__"